import { component, Component, ComponentPolicy, property } from '../../../concepts/objects';

const meetingDef = {
    name: 'Feature',
    implements: [],
    // mutation: meetingMutate,
    // propertyLayout: meetingPropertyLayout,
};

@component(meetingDef)
export class Feature extends Component {

    protected get policy() {
        return ComponentPolicy.noChildren('Feature');
    }

    @property({ type: 'string' })
    public name!: string;

    @property({ type: 'boolean' })
    public enabled!: boolean;
}
